import * as motion from "motion/react-client"
import { useState } from "react"

export const ToggleSwitch = ({isOn, setIsOn, title}: {isOn:boolean, setIsOn: (newVal: boolean) => void, title: string}) => {
    const toggleSwitch = () => setIsOn(!isOn)

    return (
      <div style={{display: 'flex', flexDirection: 'column', alignContent: 'center', justifyContent: 'center', alignItems: 'center', gap: '1rem'}}>
        <div style={{textAlign: 'center'}}>{title}</div>
        <motion.button
            layout
            className="toggle-container"
            style={{
                ...container,
                justifyContent: "flex-" + (!isOn ? "start" : "end"),
                backgroundColor: "#BCBCBC",
                alignItems: 'center'
            }}
            onClick={toggleSwitch}
        >
            <motion.div
                className="toggle-handle"
                style={{...handle, backgroundColor: "#1F1F1F"}}
                layout
                transition={{
                    type: "spring",
                    visualDuration: 0.3,
                    bounce: 0.3,
                }}
            />
        </motion.button>
        </div>
    )
}

/**
 * ==============   Styles   ================
 */

const container = {
    width: 65,
    height: 35,
    borderRadius: 50,
    cursor: "pointer",
    display: "flex",
    padding: 3,
}

const handle = {
    width: 29,
    height: 29,
    borderRadius: "50%",
}
